<template>
  <div>
    <Drawer
      :title="changeModalTitle"
      v-model="changeModal"
      width="800"
      @on-close="formReset"
      :mask-closable="false">
      <Form :model="changeForm" ref="changeForm" :rules="changeRule">
        <Alert show-icon v-if="errorMsgShow" type="error">{{ errorMsg }}</Alert>
        <FormItem prop="protocol" label="规则">
          <Select v-model="changeForm.protocol">
            <Option value="tcp" key="tcp">TCP规则</Option>
            <Option value="udp" key="udp">UDP规则</Option>
            <Option value="icmp" key="icmp">ICMP规则</Option>
          </Select>
        </FormItem>
        <FormItem prop="direction" label="方向">
          <Select v-model="changeForm.direction">
            <Option value="ingress" key="ingress">入口</Option>
            <Option value="egress" key="egress">出口</Option>
          </Select>
        </FormItem>
        <FormItem prop="open_port" label="打开端口" v-if="changeForm.protocol !== 'icmp'">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>您选择的TCP和UDP规则可能会打开一个或一组端口.选择"端口范围"，您需要提供开始和结束端口的范围.对于ICMP规则您需要指定ICMP类型和代码.</p>
            </div>
          </tooltip>
          <Select v-model="changeForm.open_port">
            <Option value="port" key="port">端口</Option>
            <Option value="port_range" key="port_range">端口范围</Option>
            <Option value="all_port" key="all_port">所有端口</Option>
          </Select>
        </FormItem>
        <FormItem prop="port" v-if="changeForm.open_port === 'port' && changeForm.protocol !== 'icmp'" label="端口">
          <tooltip placement="right" transfer max-width="200" style="margin-right: 10px">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>输入大于等于1，小于等于65535的整数</p>
            </div>
          </tooltip>
          <InputNumber :min="1" :max="65535" v-model="changeForm.port"></InputNumber>
        </FormItem>
        <div v-if="changeForm.protocol === 'icmp'">
          <FormItem label="类型">
            <tooltip placement="right" transfer max-width="200" style="margin-right: 10px">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>输入大于等于-1，小于等于255的整数</p>
              </div>
            </tooltip>
            <InputNumber v-model="changeForm.port_range_min" :min="-1" :max="255" placeholder="选填"></InputNumber>
          </FormItem>
          <FormItem label="编码">
            <tooltip placement="right" transfer max-width="200" style="margin-right: 10px">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>输入大于等于-1，小于等于255的整数</p>
              </div>
            </tooltip>
            <InputNumber v-model="changeForm.port_range_max" :min="-1" :max="255" placeholder="选填"></InputNumber>
          </FormItem>
        </div>
        <div v-else-if="changeForm.open_port === 'port_range'">
          <FormItem prop="port_range_min" label="起始端口号">
            <tooltip placement="right" transfer max-width="200" style="margin-right: 10px">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>输入大于等于1，小于等于65535的整数</p>
              </div>
            </tooltip>
            <InputNumber v-model="changeForm.port_range_min" :min="1" :max="65535"></InputNumber>
          </FormItem>
          <FormItem prop="port_range_max" label="终止端口号">
            <tooltip placement="right" transfer max-width="200" style="margin-right: 10px">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>输入大于等于1，小于等于65535的整数</p>
              </div>
            </tooltip>
            <InputNumber v-model="changeForm.port_range_max" :min="1" :max="65535"></InputNumber>
          </FormItem>
        </div>
        <FormItem label="远程" prop="remote">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>您必须指定允许通过该规则的流量来源。可以通过以下两种方式实现：CIDR(网络地址)或者来源地址组(安全组)。</p>
              <p>如果选择一个安全组作为来访源地址，则该安全组中的任何实例都被允许使用该规则访问任一其它实例。</p>
            </div>
          </tooltip>
          <Select v-model="changeForm.remote">
            <Option value="cidr" key="cidr">网络地址</Option>
            <Option value="security_group" key="security_group">安全组</Option>
          </Select>
        </FormItem>
        <FormItem label="网络地址" v-if="changeForm.remote === 'cidr'" prop="remote_ip_prefix">
          <tooltip placement="right" transfer max-width="200">
            <Icon type="ios-help-circle-outline" size="18" />
            <div slot="content">
              <p>无类别域间路由标记(CIDR, 例如 192.168.0.0/24，或者2001:db8::/128)</p>
            </div>
          </tooltip>
          <Input v-model="changeForm.remote_ip_prefix" placeholder="" :maxlength="96" />
        </FormItem>
        <FormItem label="安全组" v-if="changeForm.remote === 'security_group'" prop="remote_group_id">
          <Select v-model="changeForm.remote_group_id">
            <Option :value="item.id" :key="item.id" v-for="item in allSecurityGroupList">{{ item.name }}<span v-if="item.id === $route.params.id"> (当前)</span></Option>
          </Select>
        </FormItem>
        <FormItem label="以太网类型" v-if="changeForm.remote === 'security_group'" prop="ethertype">
          <Select v-model="changeForm.ethertype">
            <Option value="IPv4" key="IPv4">IPv4</Option>
            <Option value="IPv6" key="IPv6">IPv6</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
          <Button style="margin-left: 8px" @click="changeModal = false">取消</Button>
        </FormItem>
      </Form>
    </Drawer>
    <Card shadow style="border-radius: unset">
      <a style="margin-right: 24px" v-on:click="$router.push({ name: 'securityGroups' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      <h3 style="color: #171d25; display: inline-block;">安全组「{{ $route.query.name }}」的规则列表</h3>
      <div style="float: right">
        <Button size="small"
                :style="{marginRight: '10px', marginBottom: '10px'}"
                icon="md-refresh"
                @click="getSecurityGroupRuleData(securityGroupRule.page)">刷新</Button>
        <Button
          size="small"
          @click="formReset(); changeModal = true; changeModalTitle = '创建规则';"
          type="primary"
          :style="{ marginBottom: '10px'}"
          icon="md-add">创建规则</Button>
      </div>
    </Card>
    <Card shadow style="margin-top: 5px">
      <Table
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="securityGroupRule.data"
        :columns="securityGroupRule.columns">
      </Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ securityGroupRule.data.length }} 条记录，总共 {{ securityGroupRule.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="securityGroupRule.count"
            :current="securityGroupRule.page"
            :page-size="securityGroupRule.size"
            @on-change="getSecurityGroupRuleData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudSecurityGroupRule, deletePrivateCloudSecurityGroupRule,
  changePrivateCloudSecurityGroupRule } from '@/api/private-cloud/security-group-rule'
import { getPrivateCloudAllSecurityGroup } from '@/api/private-cloud/security-group'

export default {
  components: {
  },
  data () {
    return {
      tableLoading: false,
      securityGroupRule: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '方向',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'direction',
            render: (h, params) => {
              let result = ''
              if (params.row.direction === 'ingress') {
                result = '入口'
              } else if (params.row.direction === 'egress') {
                result = '出口'
              }
              return h('span', result)
            }
          },
          {
            title: '以太网类型',
            align: 'center',
            minWidth: 150,
            tooltip: true,
            key: 'ethertype'
          },
          {
            title: 'IP协议',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            key: 'protocol',
            render: (h, params) => {
              let result = params.row.protocol
              if (!params.row.protocol) {
                result = '任何'
              }
              return h('span', result)
            }
          },
          {
            title: '端口范围',
            align: 'center',
            minWidth: 100,
            tooltip: true,
            render: (h, params) => {
              let result = '任何'
              if (params.row.port_range_min && params.row.port_range_max) {
                if (params.row.port_range_min === params.row.port_range_max) {
                  result = params.row.port_range_max
                } else {
                  result = params.row.port_range_min + ' - ' + params.row.port_range_max
                }
              }
              return h('span', result)
            }
          },
          {
            title: '远程IP前缀',
            align: 'center',
            minWidth: 150,
            tooltip: true,
            key: 'remote_ip_prefix',
            render: (h, params) => {
              let result = params.row.remote_ip_prefix
              if (!params.row.protocol && !params.row.remote_ip_prefix && !params.row.remote_ip_prefix) {
                if (params.row.ethertype === 'IPv4') {
                  result = '0.0.0.0/0'
                } else if (params.row.ethertype === 'IPv6') {
                  result = '::/0'
                }
              }
              return h('span', result)
            }
          },
          {
            title: '远程安全组',
            align: 'center',
            minWidth: 200,
            tooltip: true,
            key: 'remote_group_id',
            render: (h, params) => {
              let result = params.row.remote_group_id
              if (params.row.remote_group_id === this.$route.params.id) {
                result += ' (当前)'
              }
              return h('span', result)
            }
          },
          {
            title: '创建时间',
            align: 'center',
            minWidth: 200,
            key: 'created_at',
            render: (h, params) => {
              return h('span', params.row.created_at ? moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            align: 'center',
            minWidth: 80,
            render: (h, params) => {
              return h('div', [
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      changeModalTitle: '创建规则',
      changeModal: false,
      changeLoading: false,
      changeForm: {
        protocol: 'tcp',
        direction: 'ingress',
        port_range_min: null,
        port_range_max: null,
        remote_ip_prefix: '0.0.0.0/0',
        remote_group_id: '',
        ethertype: 'IPv4',
        open_port: 'port',
        port: null,
        remote: 'cidr'
      },
      changeRule: {
        protocol: [
          { required: true, message: '请选择规则', trigger: 'change' }
        ],
        direction: [
          { required: true, message: '请选择方向', trigger: 'change' }
        ],
        open_port: [
          { required: true, message: '请选择打开端口', trigger: 'change' }
        ],
        port: [
          { required: true, type: 'number', message: '请填写端口号', trigger: 'blur' }
        ],
        port_range_min: [
          { required: true, type: 'number', message: '请填写起始端口号', trigger: 'blur' }
        ],
        port_range_max: [
          { required: true, type: 'number', message: '请填写终止端口号', trigger: 'blur' }
        ],
        remote: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        remote_ip_prefix: [
          { required: true, message: '请填写网络地址', trigger: 'blur' }
        ],
        remote_group_id: [
          { required: true, message: '请选择远程安全组', trigger: 'change' }
        ],
        ethertype: [
          { required: true, message: '请选择以太网类型', trigger: 'blur' }
        ]
      },
      allSecurityGroupList: [],
      errorMsg: '',
      errorMsgShow: false
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.getSecurityGroupRuleData()
      this.getAllSecurityGroupList()
    },
    // 获取规则列表数据
    getSecurityGroupRuleData (value = 1) {
      if (this.$route.params.id) {
        this.securityGroupRule.page = value
        let params = {
          page: this.securityGroupRule.page,
          size: this.securityGroupRule.size,
          security_group_id: this.$route.params.id
        }
        this.tableLoading = true
        getPrivateCloudSecurityGroupRule(params).then(res => {
          this.securityGroupRule.data = res.data.results
          this.securityGroupRule.count = res.data.count
          this.tableLoading = false
        }).catch(res => {
          this.tableLoading = false
          if (res.request) {
            this.$Notice.error({
              title: '获取规则列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取规则列表失败！服务器无响应'
            })
          }
        })
      }
    },
    // 删除规则
    delete (row) {
      deletePrivateCloudSecurityGroupRule(row.id).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getSecurityGroupRuleData()
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！服务器无响应'
          })
        }
      })
    },
    // 表单重置
    formReset () {
      this.changeForm = {
        protocol: 'tcp',
        direction: 'ingress',
        port_range_min: null,
        port_range_max: null,
        remote_ip_prefix: '0.0.0.0/0',
        remote_group_id: '',
        ethertype: 'IPv4',
        open_port: 'port',
        port: null,
        remote: 'cidr'
      }
    },
    // 提交规则编辑表单
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          let reqData = {
            security_group_id: this.$route.params.id,
            protocol: this.changeForm.protocol,
            direction: this.changeForm.direction
          }
          if (this.changeForm.protocol === 'icmp') {
            reqData.port_range_min = this.changeForm.port_range_min
            reqData.port_range_max = this.changeForm.port_range_max
          } else {
            if (this.changeForm.open_port === 'port') {
              reqData.port_range_min = this.changeForm.port
              reqData.port_range_max = this.changeForm.port
            } else if (this.changeForm.open_port === 'all_port') {
              reqData.port_range_min = 1
              reqData.port_range_max = 65535
            } else if (this.changeForm.open_port === 'port_range') {
              reqData.port_range_min = this.changeForm.port_range_min
              reqData.port_range_max = this.changeForm.port_range_max
            } else {
              this.$Notice.error({ title: '请选择打开端口！' })
              return
            }
          }
          if (this.changeForm.remote === 'cidr') {
            reqData.remote_ip_prefix = this.changeForm.remote_ip_prefix
          } else if (this.changeForm.remote === 'security_group') {
            reqData.remote_group_id = this.changeForm.remote_group_id
            reqData.ethertype = this.changeForm.ethertype
          } else {
            this.$Notice.error({ title: '请选择远程方式！' })
            return
          }
          changePrivateCloudSecurityGroupRule(reqData).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.getSecurityGroupRuleData()
            this.changeModal = false
            this.changeLoading = false
            this.formReset()
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应'
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 获取所有安全组
    getAllSecurityGroupList () {
      getPrivateCloudAllSecurityGroup().then(res => {
        this.allSecurityGroupList = res.data
      })
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
